import { RTMCategory as Events } from '@ews/zlt-events';

export { Events };

export type EventType = keyof typeof Events;

export const EventPriority: EventType[] = [
    "Alarm",
    "ActiveOutput",
    //"TechnicalMessage",
    "Disablement",
    //"TestCondition"
    "Fault",
];

export const RTMFieldOrder: EventType[] = [
    "Alarm", "TestCondition", "Fault", "TechnicalMessage", "Disablement", "ActiveOutput", "Confirmation", "ExtinguishingEvent"
];

export const EventTranslation: Record<EventType, string> = {
    None: '',
    Alarm: 'TD_ALARME',
    Fault: 'TD_STOERUNGEN',
    Disablement: 'TD_ABSCHALTUNGEN',
    TechnicalMessage: 'TD_TECHNISCHE_MELDUNGEN',
    ActiveOutput: '[SID_MNU_TAB_ACT_OUTP]',
    Confirmation: '[SID_MNU_TAB_ACKN]',
    ExtinguishingEvent: 'TD_LOESCHEREIGNISSE',
    TestCondition: 'TD_PRUEFZUSTAND'
};

export const SortRTMFieldOrder: Record<EventType, number> =
{
    "None": -1,
    "Alarm": 1,
    "ExtinguishingEvent": 2,
    "ActiveOutput": 3,
    "Confirmation": 4,
    "TechnicalMessage": 5,
    "Fault": 6,
    "Disablement": 7,
    "TestCondition": 8,
};




export type EventItemType = {
    group: string;
    title: string;
    time: string;
};

export type EventObject = {
    title: string;
    type: EventType;
    list: EventItemType[];
};